import React from 'react';
import '../styles/global.css';
import { useConfig } from '../config/ConfigContext'; // Import useConfig hook

/**
 * Activity component to display interactive activities related to the lecture
 * This is a placeholder for Phase 2 implementation
 * @param {Object} props - Component props
 * @param {Object} props.lecture - Lecture data object
 * @returns {JSX.Element} Activity component
 */
const Activity = ({ lecture }) => {
  const { theme } = useConfig(); // Get theme from context

  // Check if lecture has activity content
  const hasContent = lecture?.activityContent || false;
  
  return (
    <div className="activity-section" style={{ padding: '20px' }}>
      {hasContent ? (
        <div className="activity-content" 
          style={{
            padding: '20px',
            backgroundColor: 'white',
            borderRadius: theme.borderRadius.medium,
            boxShadow: theme.boxShadow.small
          }}
          dangerouslySetInnerHTML={{ __html: lecture.activityContent }} 
        />
      ) : (
        <div className="activity-placeholder" style={{
          background: theme.colors.lightGray,
          border: `1px solid ${theme.colors.mediumGray}`,
          borderRadius: theme.borderRadius.medium,
          padding: '40px',
          textAlign: 'center',
          minHeight: '300px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <div style={{ maxWidth: '500px' }}>
            <h3 style={{ 
              color: theme.colors.primary, 
              marginBottom: '15px',
              fontFamily: theme.fonts.secondary
            }}>
              Coming Soon
            </h3>
            <p style={{ color: theme.colors.textLight }}>
              Interactive activities for this lecture will be available in a future update.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Activity;
